import { ComponentProps, FC } from "react";

import { cn } from "@/lib/utils";

type CardProps = ComponentProps<"div">;
type CardHeaderProps = ComponentProps<"div">;
type CardTitleProps = ComponentProps<"div">;
type CardDescriptionProps = ComponentProps<"div">;
type CardContentProps = ComponentProps<"div">;
type CardFooterProps = ComponentProps<"div">;

export const Card: FC<CardProps> = ({ className, ...props }) => (
  <div
    data-slot="card"
    className={cn(
      "bg-card text-card-foreground rounded-lg border shadow-sm",
      className,
    )}
    {...props}
  />
);

export const CardHeader: FC<CardHeaderProps> = ({ className, ...props }) => (
  <div
    data-slot="card-header"
    className={cn("flex flex-col gap-1.5 p-6", className)}
    {...props}
  />
);

export const CardTitle: FC<CardTitleProps> = ({ className, ...props }) => (
  <div
    data-slot="card-title"
    className={cn("leading-none font-medium tracking-tight", className)}
    {...props}
  />
);

export const CardDescription: FC<CardDescriptionProps> = ({
  className,
  ...props
}) => (
  <div
    data-slot="card-description"
    className={cn("text-muted-foreground text-sm", className)}
    {...props}
  />
);

export const CardContent: FC<CardContentProps> = ({ className, ...props }) => (
  <div
    data-slot="card-content"
    className={cn("p-6 pt-0", className)}
    {...props}
  />
);

export const CardFooter: FC<CardFooterProps> = ({ className, ...props }) => (
  <div
    data-slot="card-footer"
    className={cn("flex items-center p-6 pt-0", className)}
    {...props}
  />
);
